/** @format */

module.exports = {
  publicKey: "4e0c87b0f72870402a0fe4c9a32186bd",
  hostnameId: "aspire",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js